import { useState } from 'react';
import { useProductComparison } from '@/contexts/ProductComparisonContext';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Scale, X } from 'lucide-react';
import { formatCurrency } from '@/utils/currency';
import '../../styles/doughnut-shop.css';

export const FloatingComparisonButton = () => {
  const { comparisonProducts, removeFromComparison, clearComparison } = useProductComparison();
  const [isExpanded, setIsExpanded] = useState(false);
  
  const comparisonCount = comparisonProducts.length;

  if (comparisonCount === 0) return null;

  return (
    <div className="fixed right-6 bottom-6 z-50 animate-in fade-in slide-in-from-right-2 duration-300">
        {isExpanded && (
          <div className="mb-4 bg-white rounded-lg shadow-xl border border-doughnut-primary/20 p-4 w-80 animate-in slide-in-from-bottom-2 duration-300">
            
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-semibold text-doughnut-dark">Comparison ({comparisonCount})</h3>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsExpanded(false)}
                className="h-6 w-6 p-0"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
            
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {comparisonProducts.map((product) => (
                <div
                  key={product.id}
                  className="flex items-center gap-3 p-2 bg-doughnut-light rounded-lg"
                >
                  <img
                    src={product.image_url || '/images/doughnut-placeholder.jpg'}
                    alt={product.name}
                    className="w-10 h-10 object-cover rounded"
                  />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-doughnut-dark truncate">
                      {product.name}
                    </p>
                    <p className="text-sm text-doughnut-primary font-semibold">
                      {formatCurrency(product.price)}
                    </p>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => removeFromComparison(product.id)}
                    className="h-6 w-6 p-0 text-red-500 hover:text-red-700"
                  >
                    <X className="h-3 w-3" />
                  </Button>
                </div>
              ))}
            </div>
            
            <div className="flex gap-2 mt-4">
              <Button
                variant="outline"
                size="sm"
                onClick={clearComparison}
                className="flex-1 btn-doughnut-outline"
              >
                Clear All
              </Button>
              <Button
                size="sm"
                className="flex-1 btn-doughnut-solid"
                onClick={() => {
                  // Navigate to comparison page
                  window.location.href = '/product-comparison';
                }}
              >
                Compare
              </Button>
            </div>
          </div>
        )}

      <Button
        onClick={() => setIsExpanded(!isExpanded)}
        className="btn-doughnut-solid rounded-full shadow-lg h-14 w-14 p-0 relative"
      >
        <Scale className="h-6 w-6" />
        <Badge
          variant="secondary"
          className="absolute -top-2 -right-2 bg-doughnut-secondary text-white border-2 border-white"
        >
          {comparisonCount}
        </Badge>
      </Button>
    </div>
  );
};